import { makeStyles } from '@material-ui/styles';
import IconAddOutline from 'assets/img/IconAddOutline';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

type AddDietCalendarTileProps = {
  href: string;
};

const useStyles = makeStyles({
  root: {
    height: '120px',
    width: '100%',
    color: grayColor[6],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const AddDietCalendarTile = ({ href }: AddDietCalendarTileProps) => {
  const classes = useStyles();

  return (
    <a className={classes.root} href={href}>
      <IconAddOutline />
    </a>
  );
};

export default AddDietCalendarTile;
